export const MAX_RECORDS_PER_PAGE = 20;

export const CRIMINAL_ORIGIN_DISPLAY_MAPPING = {
  CSGT_XCG: "Cảnh Báo Xe Cơ Giới", // http://canhbaoxcg.vr.org.vn
  CSGT_DANGKIEM: "Tra cứu Cảnh Sát Giao Thông", // https://tracuu.csgt.vn
  VIETNAM_REGISTER: "Cục Đăng Kiểm Việt Nam",
  CSGT_VN: "Cục Cảnh Sát Giao Thông!", // https://www.csgt.vn
  CSGT_EHUB: "VNeTraffic", // https://ehubapi.gtelcds.vn
  CSGT: "Dữ liệu cũ Cục Cảnh Sát Giao Thông", // https://phatnguoixe.com
  TTDK: "TTDK", // Hệ thống TTDK
  VEHICLE_CONDITION: "VEHICLE_CONDITION", // Trạng thái tình trạng xe, bao gồm tai nạn và thuỷ kích.
};

export const CRIMINAL_STATUS = {
  NO: "Chưa xử phạt",
  YES: "Đã xử phạt",
  NOT_CRIMINAL: "Không vi phạm",
  API_ERROR: "Lỗi tra cứu",
};
